import { ca } from '@cian/analytics';

export function trackMortgageBannerShow() {
  ca('eventSite', {
    action: 'show_sopr',
    category: 'Promo',
    label: 'nb_card_morgage_banner',
    name: 'oldevent',
    useLastProducts: true,
  });
}

export function trackMortgageBannerClick() {
  ca('eventSite', {
    action: 'click_sopr',
    category: 'Promo',
    label: 'nb_card_morgage_banner',
    name: 'oldevent',
    useLastProducts: true,
  });
}
